import React from 'react';
import { Box, Container, Typography, Link, Stack, Divider } from '@mui/material';
import { company } from '../company';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ mt: 'auto', bgcolor: '#0b1f3a', color: '#cfe0f5' }}>
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          spacing={4}
        >
          <Box sx={{ maxWidth: 340 }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 800, mb: 1 }}>
              Bjørnå IT
            </Typography>
            <Typography variant="body2" sx={{ color: '#9fb6d6', lineHeight: 1.7 }}>
              Programmering, web-design og PC-reparasjon i {company.city}.
            </Typography>
          </Box>

          <Stack spacing={0.75}>
            <Typography variant="overline" sx={{ color: '#6f8bb3' }}>
              Foretaket
            </Typography>
            <Typography variant="body2">Org.nr {company.orgNr}</Typography>
            <Typography variant="body2">{company.orgForm}</Typography>
            <Typography variant="body2">
              {company.city}, {company.municipality} · Norge
            </Typography>
          </Stack>

          <Stack spacing={0.75}>
            <Typography variant="overline" sx={{ color: '#6f8bb3' }}>
              Kontakt
            </Typography>
            <Link href={`mailto:${company.email}`} sx={{ color: '#cfe0f5' }}>
              {company.email}
            </Link>
            <Link
              href={company.brregUrl}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: '#cfe0f5' }}
            >
              Brønnøysundregistrene
            </Link>
            <Link href="/fisk" sx={{ color: '#cfe0f5' }}>
              Fiskekamera
            </Link>
          </Stack>
        </Stack>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.1)' }} />

        <Typography variant="body2" sx={{ color: '#6f8bb3' }}>
          © {year} {company.legalName} · Org.nr {company.orgNr}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
